module.exports = __webpack_public_path__ + "e4720ef8.svg";